<div class="tile-for-order-product-item">
    <div class="tile-for-order-product-item__inner">
        <shared-common-item class="tile-for-order-product-item__item" [description]="description"
            [subDescription]="orderItem?.SpecialInstructions" [edit]="false" [title]="title"
            [quantity]="orderItem?.Quantity" [total]="total" [bottomPadding]="bottomPadding">
        </shared-common-item>
    </div>
</div>
